import React from 'react'
import PropTypes from 'prop-types'
import Font from '@cred/react-font'
import CtaButton from 'components/cta-button'
import { PartnerLogo } from 'components/partner-logo'
import { fireGtmEvent } from 'utils/gtm'
import DisclosureModal from 'multi-vertical/rate-table/components/disclosure-modal'
import disclaimers from 'personal-loan/rate-table/lender/disclaimers'
import styles from './styles.module.scss'

const onCtaClicked = (lenderName, widgetContext) => () => {
    const lender = { lender: lenderName }

    fireGtmEvent('ctaClick', Object.assign(lender, widgetContext))
  },

  LenderTile = ({
    lender: {
      name,
      slug,
      minRate,
      maxRate,
      minTerm,
      maxTerm,
    },
    ctaUrl,
    widgetContext,
  }) => (
    <>
      <div className={`${styles.lenderSection} mt-8`}>
        <div className={styles.logo}>
          <PartnerLogo partner={slug} />
          { !!disclaimers[slug] && (
            <DisclosureModal title="Disclaimer" name={name}>
              {disclaimers[slug]}
            </DisclosureModal>
          )}
        </div>
        <div className={styles.rate}>
          <Font type="disclaimer" className={`${styles.subtitle} mb-0 mb-sm-8`}>Fixed APR from</Font>
          <Font weight="semiBold" className={styles.number}>{minRate}% - {maxRate}%</Font>
        </div>
        <div className={styles.term}>
          <Font type="disclaimer" className={`${styles.subtitle} mb-0 mb-sm-8`}>Loan terms</Font>
          <Font weight="semiBold" className={styles.number}>{minTerm} - {maxTerm} years</Font>
        </div>
        <div className={styles.ctaSection}>
          <CtaButton href={ctaUrl} blank onClick={onCtaClicked(name, widgetContext)} small>Check Rates</CtaButton>
          <Font type="disclaimer" className={`${styles.texts} mt-8 align-center hidden-xs`}>on Credible's website</Font>
        </div>
      </div>
    </>
  )

LenderTile.propTypes = {
  lender: PropTypes.object,
  ctaUrl: PropTypes.string,
  widgetContext: PropTypes.object,
}

export { LenderTile, onCtaClicked }

export default LenderTile
